import superagentPromise from "superagent-promise";
import _superagent from "superagent";
import commonStore from "./stores/commonStore";
import { $util } from "./helper";
import authStore from "./stores/authStore";
import Cookie from "js-cookie";
import { captureMessage, captureException } from "@sentry/browser";

const superagent = superagentPromise(_superagent, global.Promise);

const API_ROOT = `${process.env.DOMAIN_URL}`;
const SASS_DOMAIN = `${process.env.REACT_APP_SASS_DOMAIN}`;
const ACCOUNT_DOMAIN = `${process.env.REACT_APP_ACCOUNT_DOMAIN}`;
const BBS_DOMAIN = `${process.env.REACT_APP_BBS_DOMAIN}`;
const NODE_ENV = `${process.env.NODE_ENV}`;
// const encode = encodeURIComponent;

// 先强制删除顶级域名的csrftoken
document.cookie =
  "rm_csrf_token=; Path=/; Domain=.robomaster.com; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
document.cookie = "rm_csrf_token=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";

let CsrfToken = Cookie.get("rm_csrf_token");

const handleErrors = (err, res) => {
  if (
    NODE_ENV !== "development" &&
    res &&
    res.status === 200 &&
    res.body &&
    (res.body.msg === "请登录后再访问" || res.body.msg === "请登录后再操作")
  ) {
    // 新老服务对于未登录返回的msg不一样。
    const lang =
      $util.getUrlQueryLocate() ||
      localStorage.getItem("lang") ||
      $util.getBrowserLanguage() ||
      "zh";
    window.location.href = $util.getLoginUrl(lang);
  }

  if (!CsrfToken) {
    CsrfToken = Cookie.get("rm_csrf_token");
  }
  if (err && err.response && err.response.status === 401) {
    authStore.logout();
  }
  if (res && res.body && res.body.status === 15 && res.body.msg === "CSRF token is invalid") {
    captureException(
      `csrf校验失败，X-CSRF-Token：${CsrfToken}, 返回错误码：${res.body.status}, 错误信息:${res.body.msg}, `
    );
  }
  // 暂时这样做 错误状态 不应该是200 后端问题
  if (res && res.body && res.body.error) {
    captureMessage(res.body.error, { req: res.req });
  }

  return err;
};

const responseBody = res => res.body;

const tokenPlugin = req => {
  if (commonStore.token) {
    req.set("authorization", `Token ${commonStore.token}`);
  }
};

const requests = {
  del: url =>
    superagent
      .del(`${API_ROOT}${url}`)
      .set("X-CSRF-Token", CsrfToken)
      .use(tokenPlugin)
      .end(handleErrors)
      .then(responseBody),
  get: url =>
    superagent
      .get(`${API_ROOT}${url}`)
      .set("X-CSRF-Token", CsrfToken)
      .use(tokenPlugin)
      .end(handleErrors)
      .then(responseBody),
  put: (url, body) =>
    superagent
      .put(`${API_ROOT}${url}`, body)
      .set("X-CSRF-Token", CsrfToken)
      .use(tokenPlugin)
      .end(handleErrors)
      .then(responseBody),
  post: (url, body) =>
    superagent
      .post(`${API_ROOT}${url}`, body)
      .set("X-CSRF-Token", CsrfToken)
      .use(tokenPlugin)
      .end(handleErrors)
      .then(responseBody)
};

const Auth = {
  current: () => requests.get("/api/members/my_info"),
  getEducations: () =>
    superagent
      .get(`${ACCOUNT_DOMAIN}/api/educations`)
      .withCredentials()
      .end(handleErrors)
      .then(responseBody),
  getWorkInfo: () =>
    superagent
      .get(`${ACCOUNT_DOMAIN}/api/occupations`)
      .withCredentials()
      .end(handleErrors)
      .then(responseBody),
  logout: () => requests.del("/api/members/logout")
};

const Games = {
  getAll: page => requests.post("/api/events/new_list", page),
  registration: registration =>
    requests.post("/api/participations/create_registration", registration),
  getApplicationById: id => requests.post("/api/participations/show_registration", id),
  getMyApplications: () => requests.post("/api/participations/list_registration"),
  getCategory: () => requests.get("/api/categories"),

  // 文档：https://test-www.robomaster.com/apidoc/1.0/apiv2events.html
  getV2Events: (lang, page, per, category_id, host_area) =>
    requests.get(
      `/api/v2/events?lang=${lang}&page=${page}&per=${per}${
        category_id ? `&category_id=${category_id}` : ""
      }${host_area ? `&host_area=${host_area}` : ""}`
    ),
  getV2Categories: lang => requests.get(`/api/v2/events/categories?lang=${lang}`),
  getV2EventLicense: (id, lang) => requests.get(`/api/v2/events/${id}/license?lang=${lang}`),
  getV2Event: (id, lang) => requests.get(`/api/v2/events/${id}?lang=${lang}`)
};

const Common = {
  getSchools: () => requests.get("/api/colleges"),
  getMessages: status => requests.get(`/api/messages${status ? "?status=" + status : ""}`),
  updateMessage: (message, id) => requests.put(`/api/messages/${id}`, message),
  // V2 新增了根据区域选择对应桶功能
  getV2UploadSts: info => requests.post("/commons/v2/terra_signature", info),
  getV2UploadUrl: object_key => requests.get(`/commons/v2/terra_url_new?object_key=${object_key}`),

  getPca: () => superagent.get("https://rm-static.djicdn.com/robomasters/public/pca-code.json"),
  getMajors: name => superagent.get(`/api/standard_majors/query_majors?edu_level=1050&name=${name}`)
};

const Teams = {
  create: team => requests.post("/api/teams/create_team", team),
  getMyTeams: () => requests.post("/api/teams/list_team"),
  getTeamInfoById: id => requests.post("/api/teams/show_team", id),
  updateTeam: team => requests.post("/api/teams/update_team", team),
  joinInTeam: application =>
    requests.post("/api/team_applications/create_gapplication", application),
  searchTeam: code => requests.post("/api/teams/search_team", code),
  updateInviteCode: query => requests.post("/api/teams/update_invite_code", query),
  updateMemberApplication: application =>
    requests.post("/api/team_applications/update_gapplication", application),
  updateTeamMember: newMember => requests.post("/api/member_teams/update_gteam_member", newMember),
  lockTeam: team => requests.post("/api/teams/lock_team", team),
  exitTeam: member => requests.post("/api/member_teams/delete_gteam_member", member),
  changeCaptain: info => requests.post("/api/teams/transfer_team", info),
  deleteTeam: team => requests.post("/api/teams/delete_team", team),
  getApplication: () => requests.post("/api/team_applications/list_gapplication"),
  createQuiz: (info, lang) => requests.post("/api/quizzes/create_quiz?locale=" + lang, info),
  getQuizeHistory: info => requests.post("/api/quizzes/list_quiz", info),
  getQuizeRoundHistory: info => requests.post("/api/quizzes/list_quiz_round", info),
  getQuizConf: info => requests.post("/api/quizzes/list_quiz_config", info),
  updateManagementMark: (id, marker) =>
    requests.put(`/api/gteam_members/${id}/update_management_mark`, {
      team_management_mark: marker
    })
};

const Recruit = {
  getPositionList: async params => await requests.post("/api/positions/positions_official", params),
  fetchJobDetail: async (id, jdIdentity) =>
    await requests.get(`/api/positions/${id}?jdIdentity=${jdIdentity || ""}`),
  getFilterItems: async () => await requests.get("/api/positions/positions_filter"),
  submit: form => requests.post("/api/participation_materials/create_input", form)
};

const Meetings = {
  submit: form => requests.post("/api/participations/create_registrationMeeting", form)
};

const SassPlatform = {
  // 穿越机相关赛事，上报提交相关信息接口。
  dockerUpload: form =>
    superagent
      .post(`${SASS_DOMAIN}/docker/create`, form)
      .withCredentials()
      .end(handleErrors)
      .then(responseBody),
  // 埋点上报接口
  report: data =>
    superagent
      .post(`${SASS_DOMAIN}/docker/statistics/add`, data)
      .withCredentials()
      .end(handleErrors)
      .then(responseBody),
  // 校验个人信息接口
  verifyPersonalInfo: () => {
    return Promise.resolve({ data: { result: 1 } });
  },
  // superagent
  //   .post(`${SASS_DOMAIN}/registration/ruleCheck`, data)
  //   .withCredentials()
  //   .end(handleErrors)
  //   .then(responseBody),
  getSTS: () =>
    superagent
      .get(`${SASS_DOMAIN}/registration/ossToken`)
      .withCredentials()
      .end(handleErrors)
      .then(responseBody),
  // 获取提交环节次数限制的比赛
  getSubmissionRules: () =>
    superagent
      .get(`${SASS_DOMAIN}/registration/getSubmissionRules`)
      .withCredentials()
      .end(handleErrors)
      .then(responseBody),
  // 通过teamid获取学校信息
  getSchoolsInfoByTeamId: teamId =>
    superagent
      .post(`${SASS_DOMAIN}/registration/getSchoolsInfo`, { teamId })
      .withCredentials()
      .end(handleErrors)
      .then(responseBody),
  // 更新学校信息
  updateSchoolInfo: data =>
    superagent
      .post(`${SASS_DOMAIN}/registration/updateSchoolsInfo`, data)
      .withCredentials()
      .end(handleErrors)
      .then(responseBody),
  // 通过学校名搜索学校
  searchSchools: data =>
    superagent
      .post(`${SASS_DOMAIN}/registration/searchSchools`, data)
      .withCredentials()
      .end(handleErrors)
      .then(responseBody),
  createSchool: data =>
    superagent
      .post(`${SASS_DOMAIN}/registration/createSchool`, { source: "registration", ...data })
      .withCredentials()
      .end(handleErrors)
      .then(responseBody),
  /**
   * 通过赛事id和队伍id获取赛事的流程和环节配置信息（从sass系统配置的环节信息）
   * 此处传队伍id的原因是可能会针对部分战队延长提交时间
   */
  getCollectionListInfo: (eventId, teamId) => {
    return superagent
      .post(`${SASS_DOMAIN}/registration/getCollectionListInfo`, { eventId, teamId })
      .withCredentials()
      .end(handleErrors)
      .then(responseBody);
  },
  /**
   * 通过teamId更新名单收集进程状态
   * @param {*} teamId 队伍id
   * @param {*} data {
   *  是否已经确认参赛信息
   *  confirmTeamInfo: true,
   * }
   * @returns
   */
  updateCollectionProcessState: (teamId, collectionId, data) => {
    return superagent
      .post(`${SASS_DOMAIN}/registration/updateCollectionProcessState`, {
        teamId,
        collectionId,
        ...data
      })
      .withCredentials()
      .end(handleErrors)
      .then(responseBody);
  },
  /**
   * 获取当前战队在收集战队参赛名单阶段的状态
   * @param {*} teamId 队伍id
   * @param {*} collectionId
   * @returns
   */
  getCollectionProcessState: (teamId, collectionId) => {
    return superagent
      .post(`${SASS_DOMAIN}/registration/getCollectionProcessState`, {
        teamId,
        collectionId
      })
      .withCredentials()
      .end(handleErrors)
      .then(responseBody);
  },
  /**
   * 通过teamId获取当前队伍所有提交过的参赛名单
   */
  getEntryLists: (eventId, teamId) => {
    return superagent
      .post(`${SASS_DOMAIN}/registration/getEntryLists`, {
        eventId,
        teamId
      })
      .withCredentials()
      .end(handleErrors)
      .then(responseBody);
  }
};

// 论坛的接口
const BbsPlatform = {
  getBBSTeamList: () => {
    return superagent
      .post(`${BBS_DOMAIN}/developers-server/rest/team/joined-team/all`)
      .withCredentials()
      .end(handleErrors)
      .then(responseBody);
  }
};

export default {
  // Articles,
  Auth,
  // Comments,
  // Profile,
  // Tags,
  Games,
  Common,
  Teams,
  Recruit,
  Meetings,
  SassPlatform,
  BbsPlatform
};



// WEBPACK FOOTER //
// ./src/agent.js